<div class="flex flex-col h-[76vh]" >
  <section class="pr-6 overflow-auto"  >
    <p class="text-xl font-semibold text-[#53565B] text-truncate" >Add <span class="font-bold text-[#25508E]" >The Basics</span> for <span class="font-bold text-[#25508E]" [matTooltip]="data?.form_name.length > 40 ? data.form_name : ''">{{data?.form_name | truncateStrPipe : 40}}</span></p>
    @if (!is_loading) {
      <div class="overflow-auto">
        <form-preview-setup-with-notes
          [fId]="data.vault_form_id"
          (updateDbFun)="updateDbFun($event)"
          (parentFun)="parentFun($event)"
          (enableSaveFun)="enableSaveFun($event)"
          [data]="data"
          [form_name]="form_name"
          [currentuserId]="currentuserId"
          [JsonDataExtractedData]="JsonDataExtractedData" >
        </form-preview-setup-with-notes>
      </div>
    }

    @if (is_loading) {
      <div class="loader-container">
        <div style="width: 100%">
          <div class="ph-col-12" style="padding: 0px !important"></div>
          <div class="flex loader-body" style="width: 100%">
            <div class="ph-item width-100per loader-body-item" style="border: 0px !important; height: auto">
              <div class="ph-col-12" style="padding: 0px !important; margin-top: 24px">
                <div class="ph-row">
                  <div class="ph-col-4" style="height: 12px"></div>
                </div>
                <div class="ph-row" style="padding: 0px !important; margin-top: 24px">
                  <div class="ph-col-6" style="height: 30px"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-4" style="height: 30px"></div>
                </div>
                <div class="ph-row" style="padding: 0px !important; margin-top: 24px">
                  <div class="ph-col-2" style="height: 30px"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-2" style="height: 30px"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-2" style="height: 30px"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </section>
  <mat-divider class="mt-6 pr-6"     ></mat-divider>

  <section class="h-[10%] pr-6 mt-6 flex justify-between"  >
    <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="back()">
      <span class="flex items-center gap-2 text-[#18191C]"
        ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
        >
      </button>
      <div
        class="w-[158px]"
        >
        @if (disable_btn) {
          <button type="submit" (click)="save()" class="app__btn--primary mt-0" >
            Continue
          </button>
        }
      </div>

    </section>
  </div>